import {isObject} from './boolean';
import {dateFormat} from './date';
import {getObjectProp} from './object';
import {API_EMAIL} from '../constants/api';
import {DATE_FORMAT_DISPLAY} from '../constants/date';

/**
 *
 * @param {object} values
 * @returns {object}
 */
export const prepareProfileSubmitPayload = values => {
  if (!isObject(values)) {
    return {};
  }
  const exclude = [API_EMAIL];
  return Object.keys(values).reduce((vals, item) => {
    if (item && !exclude.includes(item)) {
      return {
        ...vals,
        [item]: values[item],
      };
    }
    return vals;
  }, {});
};

export const prepareProfileProps = values => {
  const dob = getObjectProp(values, 'dob');
  const firstName = getObjectProp(values, 'first_name');
  const lastName = getObjectProp(values, 'last_name');
  const preferredName = getObjectProp(values, 'preferred_name', null);
  const over18 = getObjectProp(values, 'is_over_18', null);
  const smoker = getObjectProp(values, 'smokers', null);

  return {
    profilePhotoSrc: getObjectProp(values, 'profile_photo_id'),
    bio: getObjectProp(values, 'bio'),
    dob,
    dobDisplay: dateFormat(dob, DATE_FORMAT_DISPLAY),
    email: getObjectProp(values, 'email'),
    firstName,
    lastName,
    homePhone: getObjectProp(values, 'home_phone'),
    id: getObjectProp(values, 'id'),
    middleName: getObjectProp(values, 'middle_names'),
    mobile: getObjectProp(values, 'mobile'),
    preferredName: [preferredName || firstName, lastName].join(' '),
    workPhone: getObjectProp(values, 'work_phone'),
    over18: over18 !== null ? Boolean(over18) : null,
    smoker: over18 !== null ? Boolean(smoker) : null,
  };
};

export const prepareGuarantorProps = values => ({
  email: getObjectProp(values, 'email'),
  firstName: getObjectProp(values, 'first_name'),
  id: getObjectProp(values, 'id'),
  lastName: getObjectProp(values, 'last_name'),
  phone: getObjectProp(values, 'phone'),
});
